import { EventInvitation } from '@features/event-invitation/utils/models/event-invitation.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const EventInvitationActions = createActionGroup({
  source: 'Event Invitation Page',
  events: {
    'Get Event Invitation': props<{ hash: string }>(),
    'Get Event Invitation Success': props<{ invitation: EventInvitation }>(),
    'Get Event Invitation Failure': props<{ error: HttpError }>(),
  },
});

export const EventInvitationResetActions = createActionGroup({
  source: 'Event Invitation Page',
  events: {
    'Cancel Event Invitation Actions': emptyProps(),
    'Cancel Event Invitation Actions Success': emptyProps(),
    'Reset Event Invitation': emptyProps(),
  },
});
